import { useQuery } from '@tanstack/react-query';
import { candidatesApi } from '../candidatesApi';
import { candidateQueryKeys } from '../queryKeys';

export const useGetCandidate = (id: string) => {
  return useQuery({
    queryKey: candidateQueryKeys.detail(id),
    queryFn: () => candidatesApi.getCandidate(id),
  });
};
